<template lang="pug">
#search-form
  .from.area
    .short-label(:class="form.from !== null ? 'opacity-1' : '' ") From
    v-select(placeholder="From (airport, city or train station)" label="name" :options="source.destinations" v-model="form.from" @input="changeFromDestination()")
  .break-sm
  .switch.area(@click="switchDestinations()")
    svg.icon.icon--sm.icon--center(xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewbox='0 0 16 16')
      path(fill='#6C7C8C' fill-opacity='.5' d='M12.01 3H0v2h12.01v3L16 4l-3.99-4v3zM3.99 13H16v-2H3.99V8L0 12l3.99 4v-3z')
  .to.area
    .short-label To
    v-select(placeholder="To (airport, city or train station)"  label="name" :options="toDestinations" v-model="form.to")
  .break-md
  .pax.area
    .short-label Pax
    v-select(placeholder="Passengers" label="label" :options="source.paxs" v-model="form.pax")
  .break-sm
  button.area.success(@click="getRoutes()")
    svg.icon.icon--sm.icon--center(xmlns='http://www.w3.org/2000/svg' width='19' height='19' fill='none' viewbox='0 0 19 19')
      path(fill='#fff' fill-rule='evenodd' d='M6.279 11.95h-.858L0 17.38 1.619 19l5.431-5.42v-.859l.294-.304a7.03 7.03 0 0 0 4.595 1.705 7.061 7.061 0 1 0-7.061-7.06 7.03 7.03 0 0 0 1.705 4.594l-.304.294zm10.549-4.89a4.882 4.882 0 0 1-4.889 4.889A4.882 4.882 0 0 1 7.051 7.06a4.882 4.882 0 0 1 4.888-4.888 4.882 4.882 0 0 1 4.889 4.888z' clip-rule='evenodd')
    |Show Prices

  //- pre {{(toDestinations)}}
</template>

<script>
import axios from 'axios'
import { Form } from 'vform'

const END_POINT = 'external-transfer/v1/transfer'

export default {
  name: 'TransferSearchForm',
  props: {},
  data: () => ({
    source: {
      destinations: [],
      availableDestinations: [],
      paxs: []
    },
    form: new Form({
      from: null,
      to: null,
      pax: {
        label: 2,
        value: 2
      }
    })
  }),
  computed: {
    toDestinations () {
      return this.source.availableDestinations.filter(a => this.source.destinations.some(b => a.value === b.value))
    }
  },
  mounted () {
    this.loadDestinations()
  },
  methods: {
    loadDestinations () {
      const vm = this
      axios.get(`${END_POINT}/destinations`)
        .then((r) => {
          if (r.data.success) {
            vm.source.destinations = r.data.data.destinations
            // vm.source.destinations = r.data.data.destinations
            vm.source.paxs = r.data.data.paxs
            // LOAD OLD DATA
            if (vm.$route.name === 'transfer.routes') {
              vm.form.from = vm.$route.params.from ? vm.source.destinations.find((x) => vm.$route.params.from === x.slug) : null
              vm.form.to = vm.$route.params.to ? vm.source.destinations.find((x) => vm.$route.params.to === x.slug) : null
              // eslint-disable-next-line eqeqeq
              vm.form.pax = vm.$route.query.pax ? vm.source.paxs.find((x) => vm.$route.query.pax == x.value) : vm.source.paxs.find((x) => x.value == 2)
            }
          }
        })
    },
    changeFromDestination () {
      const vm = this
      vm.form.to = null
      if (vm.form.from !== null) {
        const id = vm.form.from.id
        axios.get(`${END_POINT}/destination/from/${id}`).then((r) => {
          vm.source.availableDestinations = r.data.success ? r.data.data : []
        })
      }
    },
    switchDestinations () {
      if (this.form.from !== null && this.form.to !== null) {
        const from = this.form.from
        const to = this.form.to
        this.form.from = this.source.destinations.find((x) => to.slug === x.slug)
        this.changeFromDestination()
        this.form.to = this.source.destinations.find((x) => from.slug === x.slug)
      }
    },
    getRoutes () {
      if (this.form.from === null) {
        this.$swal({ title: 'Please Select From Destination', icon: 'warning', toast: true, position: 'center-center', showConfirmButton: false, timer: 3000, timerProgressBar: true })
      } else if (this.form.to === null) {
        this.$swal({ title: 'Please Select To Destination', icon: 'warning', toast: true, position: 'center-center', showConfirmButton: false, timer: 3000, timerProgressBar: true })
      } else {
        if (this.$route.params.from === this.form.from.slug && this.$route.params.to === this.form.to.slug && this.$route.query.pax === this.form.pax.value) {
          this.$emit('e-reload-routes', true)
        } else {
          console.log('pushed')
          this.$router.push({
            name: 'transfer.routes',
            params: {
                from: this.form.from.slug,
                to: this.form.to.slug
              },
            query: {
              pax: this.form.pax.value
            }
          })
          this.$emit('e-reload-routes', true)
        }
      }
    }
  }
}
</script>

<style lang="scss">
#search-form{
  display: flex;
  width: 100%;
  flex-direction: row;
  z-index: 10;
  height: 64px;
  border-radius: 5px;
  // border: 1px solid gainsboro;
  // Positions
  .from{
    width: 28%;
    background-color: white;
    border-radius: 8px 0 0 8px;
  }
  .switch{
    width: 6%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: white;
  }
  .to{
    width: 28%;
    background-color: white;
  }
  .pax{
    width: 19%;
    background-color: white;
  }
  button.success{
    width: calc(19% + 1px);
    border: none;
    background-color: #ff8001;
    color: white;
    border-radius: 0px 5px 5px 0px;
    margin: -1px -1px -1px 0;
    svg{
      margin-right: 10px;
    }
  }
  .area:not(:last-child){
    border-right: 1px solid gainsboro;
  }
  .area{
    position: relative;
    .short-label{
      position: absolute;
      opacity: 0;
      color: gainsboro;
      width: 100%;
      padding: 0 8px;
    }
    &:focus-within{
      .short-label{
        opacity: 1;
      }
      .vs__search:focus{
        &::placeholder{
          opacity: 0;
        }
      }
    }
  }
  // Dropdowns
  .vs__dropdown-toggle{
    border: 0;
    height: 64px;
  }
  .vs__dropdown-menu{
    color: black;
  }
  .vs--single.vs--open .vs__selected{
    opacity: 0 !important;
  }

  .break-md {
    display: none;
    flex-basis: 100%;
    height: 0;
  }
  .break-sm {
    display: none;
    flex-basis: 100%;
    height: 0;
  }
  @media (max-width: 1024px) {
    height: auto;
    flex-wrap: wrap;
    // height: 140px;
    margin-bottom: 20px;
    .break-md {
      display: flex;
    }
    .from{
      width: 46%;
      margin-bottom: 10px;
      border-radius: 8px 0 0 8px;
    }
    .switch{
      width: 8%;
      margin-bottom: 10px;
    }
    .to{
      width: 46%;
      margin-bottom: 10px;
      border-radius: 0 8px 8px 0;
    }
    .pax{
      width: 46%;
      border-radius: 8px 0 0 8px;
    }
    button.success{
      width: 54%;
    }
  }
  @media (max-width: 640px) {
    height: auto;
    position: relative;
    .break-sm {
      display: flex;
    }
    .from{
      width: calc(100% - 45px);
      margin-bottom: 0;
      border-radius: 8px 0 0 0;
      border-bottom: 1px solid gainsboro;
    }
    .switch{
      position: absolute;
      right: 0;
      height: 129px;
      width: 45px;
      top: 0px;
      border-radius: 0 8px 8px 0;
    }
    .to{
      width: calc(100% - 45px);
      margin-bottom: 10px;
      border-radius: 0 0 0 8px;
    }
    .pax{
      width: 100%;
      margin-bottom: 10px;
      border-radius: 8px 8px 8px 8px;
    }
    button.success{
      width: 100%;
      border-radius: 8px 8px 8px 8px;
      padding: 10px;
    }
  }
}
</style>
